import { useState } from "react"
import { Outlet } from "@tanstack/react-router"
import { Layout } from "@mimber/ui-web"
import { AppHeader, NavigationPanel } from "@/components/blocks"
import { OrganizationGate } from "@/components/gates"

const { Header, Content } = Layout

export function OrganizationLayout() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false)

  return (
    <OrganizationGate>
      <Layout style={{ height: "100dvh", overflow: "hidden" }}>
        {/* Full-width header at top */}
        <Header
          style={{
            padding: 0,
            display: "flex",
            alignItems: "center",
            position: "sticky",
            top: 0,
            zIndex: 10,
            width: "100%",
          }}
        >
          <AppHeader onMenuClick={() => setMobileNavOpen(true)} />
        </Header>

        {/* Sidebar and content side by side, filling the remaining height below the header */}
        <Layout style={{ minHeight: 0, overflow: "hidden" }}>
          <NavigationPanel
            mobileOpen={mobileNavOpen}
            onMobileClose={() => setMobileNavOpen(false)}
          />
          <Content
            style={{
              margin: "24px 16px",
              borderRadius: "8px",
              minWidth: 0,
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </OrganizationGate>
  )
}
